import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
import researchConfig from './research-config'
import members from './members'
import papers from './papers'
import articles from './articles'
import citationStyle from './citation-style'
import files from './files'
import associations from './associations'
import prisma from './prisma'
import editor774148 from './editor'
import document from './document'
import assets from './assets'
import extraction from './extraction'
import data from './data'
import references from './references'
/**
* @see \App\Http\Controllers\ProjectController::index
* @see Http/Controllers/ProjectController.php:27
* @route '/projects'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/projects',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectController::index
* @see Http/Controllers/ProjectController.php:27
* @route '/projects'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::index
* @see Http/Controllers/ProjectController.php:27
* @route '/projects'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::index
* @see Http/Controllers/ProjectController.php:27
* @route '/projects'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectController::index
* @see Http/Controllers/ProjectController.php:27
* @route '/projects'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::index
* @see Http/Controllers/ProjectController.php:27
* @route '/projects'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::index
* @see Http/Controllers/ProjectController.php:27
* @route '/projects'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\ProjectController::store
* @see Http/Controllers/ProjectController.php:71
* @route '/projects'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/projects',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ProjectController::store
* @see Http/Controllers/ProjectController.php:71
* @route '/projects'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::store
* @see Http/Controllers/ProjectController.php:71
* @route '/projects'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectController::store
* @see Http/Controllers/ProjectController.php:71
* @route '/projects'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectController::store
* @see Http/Controllers/ProjectController.php:71
* @route '/projects'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
export const autofill = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autofill.url(options),
    method: 'post',
})

autofill.definition = {
    methods: ["post"],
    url: '/projects/autofill',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
autofill.url = (options?: RouteQueryOptions) => {
    return autofill.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
autofill.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autofill.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
const autofillForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autofill.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::autofill
* @see Http/Controllers/ProjectStatsController.php:28
* @route '/projects/autofill'
*/
autofillForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autofill.url(options),
    method: 'post',
})

autofill.form = autofillForm

/**
* @see \App\Http\Controllers\ProjectController::create
* @see Http/Controllers/ProjectController.php:61
* @route '/projects/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/projects/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectController::create
* @see Http/Controllers/ProjectController.php:61
* @route '/projects/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::create
* @see Http/Controllers/ProjectController.php:61
* @route '/projects/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::create
* @see Http/Controllers/ProjectController.php:61
* @route '/projects/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectController::create
* @see Http/Controllers/ProjectController.php:61
* @route '/projects/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::create
* @see Http/Controllers/ProjectController.php:61
* @route '/projects/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::create
* @see Http/Controllers/ProjectController.php:61
* @route '/projects/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\ProjectController::show
* @see Http/Controllers/ProjectController.php:97
* @route '/projects/{project}'
*/
export const show = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/projects/{project}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectController::show
* @see Http/Controllers/ProjectController.php:97
* @route '/projects/{project}'
*/
show.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return show.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::show
* @see Http/Controllers/ProjectController.php:97
* @route '/projects/{project}'
*/
show.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::show
* @see Http/Controllers/ProjectController.php:97
* @route '/projects/{project}'
*/
show.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectController::show
* @see Http/Controllers/ProjectController.php:97
* @route '/projects/{project}'
*/
const showForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::show
* @see Http/Controllers/ProjectController.php:97
* @route '/projects/{project}'
*/
showForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::show
* @see Http/Controllers/ProjectController.php:97
* @route '/projects/{project}'
*/
showForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\ProjectController::update
* @see Http/Controllers/ProjectController.php:150
* @route '/projects/{project}'
*/
export const update = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/projects/{project}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ProjectController::update
* @see Http/Controllers/ProjectController.php:150
* @route '/projects/{project}'
*/
update.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return update.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::update
* @see Http/Controllers/ProjectController.php:150
* @route '/projects/{project}'
*/
update.patch = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ProjectController::update
* @see Http/Controllers/ProjectController.php:150
* @route '/projects/{project}'
*/
const updateForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectController::update
* @see Http/Controllers/ProjectController.php:150
* @route '/projects/{project}'
*/
updateForm.patch = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\ProjectController::destroy
* @see Http/Controllers/ProjectController.php:173
* @route '/projects/{project}'
*/
export const destroy = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/projects/{project}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ProjectController::destroy
* @see Http/Controllers/ProjectController.php:173
* @route '/projects/{project}'
*/
destroy.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::destroy
* @see Http/Controllers/ProjectController.php:173
* @route '/projects/{project}'
*/
destroy.delete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ProjectController::destroy
* @see Http/Controllers/ProjectController.php:173
* @route '/projects/{project}'
*/
const destroyForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProjectController::destroy
* @see Http/Controllers/ProjectController.php:173
* @route '/projects/{project}'
*/
destroyForm.delete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\ProjectController::settings
* @see Http/Controllers/ProjectController.php:134
* @route '/projects/{project}/settings'
*/
export const settings = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(args, options),
    method: 'get',
})

settings.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectController::settings
* @see Http/Controllers/ProjectController.php:134
* @route '/projects/{project}/settings'
*/
settings.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return settings.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectController::settings
* @see Http/Controllers/ProjectController.php:134
* @route '/projects/{project}/settings'
*/
settings.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::settings
* @see Http/Controllers/ProjectController.php:134
* @route '/projects/{project}/settings'
*/
settings.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: settings.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectController::settings
* @see Http/Controllers/ProjectController.php:134
* @route '/projects/{project}/settings'
*/
const settingsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::settings
* @see Http/Controllers/ProjectController.php:134
* @route '/projects/{project}/settings'
*/
settingsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectController::settings
* @see Http/Controllers/ProjectController.php:134
* @route '/projects/{project}/settings'
*/
settingsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: settings.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

settings.form = settingsForm

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
export const searchEquations = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchEquations.url(args, options),
    method: 'get',
})

searchEquations.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/search-equations',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquations.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return searchEquations.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquations.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: searchEquations.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquations.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: searchEquations.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
const searchEquationsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchEquations.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquationsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchEquations.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::searchEquations
* @see Http/Controllers/ProjectStatsController.php:48
* @route '/projects/{project}/search-equations'
*/
searchEquationsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: searchEquations.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

searchEquations.form = searchEquationsForm

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
export const stats = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: stats.url(args, options),
    method: 'get',
})

stats.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
stats.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return stats.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
stats.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
stats.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: stats.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
const statsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
statsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectStatsController::stats
* @see Http/Controllers/ProjectStatsController.php:68
* @route '/projects/{project}/stats'
*/
statsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: stats.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

stats.form = statsForm

/**
* @see \App\Http\Controllers\PrismaController::prismaStats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
export const prismaStats = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: prismaStats.url(args, options),
    method: 'get',
})

prismaStats.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/prisma-stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PrismaController::prismaStats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
prismaStats.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return prismaStats.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PrismaController::prismaStats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
prismaStats.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: prismaStats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::prismaStats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
prismaStats.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: prismaStats.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PrismaController::prismaStats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
const prismaStatsForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: prismaStats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::prismaStats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
prismaStatsForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: prismaStats.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PrismaController::prismaStats
* @see Http/Controllers/PrismaController.php:22
* @route '/projects/{project}/prisma-stats'
*/
prismaStatsForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: prismaStats.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

prismaStats.form = prismaStatsForm

/**
* @see \App\Http\Controllers\DocumentController::editor
* @see Http/Controllers/DocumentController.php:23
* @route '/projects/{project}/editor'
*/
export const editor = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: editor.url(args, options),
    method: 'get',
})

editor.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/editor',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DocumentController::editor
* @see Http/Controllers/DocumentController.php:23
* @route '/projects/{project}/editor'
*/
editor.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return editor.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DocumentController::editor
* @see Http/Controllers/DocumentController.php:23
* @route '/projects/{project}/editor'
*/
editor.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: editor.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DocumentController::editor
* @see Http/Controllers/DocumentController.php:23
* @route '/projects/{project}/editor'
*/
editor.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: editor.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DocumentController::editor
* @see Http/Controllers/DocumentController.php:23
* @route '/projects/{project}/editor'
*/
const editorForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: editor.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DocumentController::editor
* @see Http/Controllers/DocumentController.php:23
* @route '/projects/{project}/editor'
*/
editorForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: editor.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DocumentController::editor
* @see Http/Controllers/DocumentController.php:23
* @route '/projects/{project}/editor'
*/
editorForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: editor.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

editor.form = editorForm

/**
* @see \App\Http\Controllers\FileController::importMethod
* @see Http/Controllers/FileController.php:26
* @route '/projects/{project}/import'
*/
export const importMethod = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: importMethod.url(args, options),
    method: 'get',
})

importMethod.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/import',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FileController::importMethod
* @see Http/Controllers/FileController.php:26
* @route '/projects/{project}/import'
*/
importMethod.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return importMethod.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FileController::importMethod
* @see Http/Controllers/FileController.php:26
* @route '/projects/{project}/import'
*/
importMethod.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: importMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::importMethod
* @see Http/Controllers/FileController.php:26
* @route '/projects/{project}/import'
*/
importMethod.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: importMethod.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\FileController::importMethod
* @see Http/Controllers/FileController.php:26
* @route '/projects/{project}/import'
*/
const importMethodForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: importMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::importMethod
* @see Http/Controllers/FileController.php:26
* @route '/projects/{project}/import'
*/
importMethodForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: importMethod.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FileController::importMethod
* @see Http/Controllers/FileController.php:26
* @route '/projects/{project}/import'
*/
importMethodForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: importMethod.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

importMethod.form = importMethodForm

/**
* @see \App\Http\Controllers\ProjectRunsController::activity
* @see Http/Controllers/ProjectRunsController.php:16
* @route '/projects/{project}/activity'
*/
export const activity = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activity.url(args, options),
    method: 'get',
})

activity.definition = {
    methods: ["get","head"],
    url: '/projects/{project}/activity',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProjectRunsController::activity
* @see Http/Controllers/ProjectRunsController.php:16
* @route '/projects/{project}/activity'
*/
activity.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return activity.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProjectRunsController::activity
* @see Http/Controllers/ProjectRunsController.php:16
* @route '/projects/{project}/activity'
*/
activity.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: activity.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectRunsController::activity
* @see Http/Controllers/ProjectRunsController.php:16
* @route '/projects/{project}/activity'
*/
activity.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: activity.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProjectRunsController::activity
* @see Http/Controllers/ProjectRunsController.php:16
* @route '/projects/{project}/activity'
*/
const activityForm = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectRunsController::activity
* @see Http/Controllers/ProjectRunsController.php:16
* @route '/projects/{project}/activity'
*/
activityForm.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProjectRunsController::activity
* @see Http/Controllers/ProjectRunsController.php:16
* @route '/projects/{project}/activity'
*/
activityForm.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: activity.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

activity.form = activityForm

const projects = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    autofill: Object.assign(autofill, autofill),
    create: Object.assign(create, create),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    settings: Object.assign(settings, settings),
    researchConfig: Object.assign(researchConfig, researchConfig),
    members: Object.assign(members, members),
    searchEquations: Object.assign(searchEquations, searchEquations),
    stats: Object.assign(stats, stats),
    papers: Object.assign(papers, papers),
    articles: Object.assign(articles, articles),
    citationStyle: Object.assign(citationStyle, citationStyle),
    files: Object.assign(files, files),
    associations: Object.assign(associations, associations),
    prismaStats: Object.assign(prismaStats, prismaStats),
    prisma: Object.assign(prisma, prisma),
    editor: Object.assign(editor, editor774148),
    document: Object.assign(document, document),
    assets: Object.assign(assets, assets),
    extraction: Object.assign(extraction, extraction),
    data: Object.assign(data, data),
    references: Object.assign(references, references),
    import: Object.assign(importMethod, importMethod),
    activity: Object.assign(activity, activity),
}

export default projects